var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticStyle:{"width":"50px","height":"50px","margin":"50px auto"},on:{"click":_vm.start}},[_vm._v("开始录音")])
}
var staticRenderFns = []

export { render, staticRenderFns }